import axios from 'axios';
import { SERVER_URL } from '../App';
import { trackEvent } from './analytics';
import { isAutomated } from './metrics';

function creds(config = {}) {
    return {
        withCredentials: true,
        ...config,
    };
}

export async function listRemoteBuilds() {
    const { data } = await axios.get(`${SERVER_URL()}builds/`, creds());
    return Array.isArray(data?.builds) ? data.builds : [];
}

export async function createRemoteBuild(payload) {
    const { data } = await axios.post(
        `${SERVER_URL()}builds/`,
        payload,
        creds({ headers: { 'Content-Type': 'application/json' } })
    );
    trackEvent('save_build');
    return data?.build;
}

export async function getRemoteBuild(buildId) {
    const { data } = await axios.get(`${SERVER_URL()}builds/${encodeURIComponent(buildId)}`, creds());
    return data?.build;
}

export async function updateRemoteBuild(buildId, payload) {
    const { data } = await axios.patch(
        `${SERVER_URL()}builds/${encodeURIComponent(buildId)}`,
        payload,
        creds({ headers: { 'Content-Type': 'application/json' } })
    );
    return data?.build;
}

export async function deleteRemoteBuild(buildId) {
    const { data } = await axios.delete(`${SERVER_URL()}builds/${encodeURIComponent(buildId)}`, creds());
    return data;
}

export async function importLocalBuilds(payload) {
    const { data } = await axios.post(
        `${SERVER_URL()}builds/import-local`,
        payload,
        creds({ headers: { 'Content-Type': 'application/json' } })
    );
    return data;
}

export async function syncAnonBuild(payload) {
    const { data } = await axios.put(
        `${SERVER_URL()}builds/sync-anon`,
        payload,
        creds({ headers: { 'Content-Type': 'application/json' } })
    );
    return data;
}

export async function deleteAnonBuild(payload) {
    const { data } = await axios.delete(
        `${SERVER_URL()}builds/sync-anon`,
        creds({ data: payload, headers: { 'Content-Type': 'application/json' } })
    );
    return data;
}

export async function getPublicBuild(userSlug, buildCode) {
    const { data } = await axios.get(
        `${SERVER_URL()}public-builds/${encodeURIComponent(userSlug)}/${encodeURIComponent(buildCode)}`,
        creds()
    );
    return data;
}

export async function listCommunityBuilds(params = {}) {
    const query = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
        if (v == null || v === '') return;
        query.set(k, String(v));
    });
    const suffix = query.toString() ? `?${query.toString()}` : '';
    const { data } = await axios.get(`${SERVER_URL()}community-builds${suffix}`, creds());
    return data || { results: [], total: 0, page: 1, page_size: 24 };
}

export async function listCommunityTopCreators(params = {}) {
    const query = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
        if (v == null || v === '') return;
        query.set(k, String(v));
    });
    const suffix = query.toString() ? `?${query.toString()}` : '';
    const { data } = await axios.get(`${SERVER_URL()}community-top-creators${suffix}`, creds());
    return data || { results: [], total: 0, page: 1, page_size: 32, has_more: false };
}

export async function listLikedCommunityBuilds(params = {}) {
    // icons=1: liked builds are shown as full grid cards, which draw the gear
    // block from the listing itself. The community grid does not, and so does
    // not ask for them.
    return listCommunityBuilds({ ...params, liked: '1', icons: '1' });
}

export async function toggleCommunityBuildLike(buildId) {
    const { data } = await axios.post(`${SERVER_URL()}community-builds/${encodeURIComponent(buildId)}/like`, {}, creds());
    return data || { liked: false, likes: 0 };
}

export async function recordCommunityBuildView(buildId) {
    const { data } = await axios.post(`${SERVER_URL()}community-builds/${encodeURIComponent(buildId)}/view`, { automated: isAutomated() }, creds());
    return data || { views: 0 };
}
